import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { ProductionsDto } from "../../../../dtos/documents/Productions/ProductionsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { ProductionsModel } from "../../../../models/Documents/Productions/ProductionsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFSecondTab } from "../../../Shared/NewForms/NFSecondTab";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import ProductionsDetailSkeleton from "./ProductionsDetailSkeleton";
import { ProductionsDetailFooter } from "./ProductionsDetailFooter";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel,saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: ProductionsDto | null;
  modelUpdatedEvent: (newModel: ProductionsDto) => void;
}

export const ProductionsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ProductionsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("productionMaterialsAndWorks");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Productions");

  useEffect(() => {
    console.log(model);
    register("productionMaterialsAndWorks");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("divisionId", model.divisionId);
      setValue("createdDate", model.createdDate);
      setValue("comment", model.comment);
      setValue("productionMaterialsAndWorks", model.productionMaterialsAndWorks);
      setValue("productionManufacturedProducts", model.productionManufacturedProducts);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: ProductionsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: ProductionsDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ProductionsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ProductionsDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.Productions.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Materials and works"} />
        <NFSecondTab title={"Manufactured products"} />
        <NFSecondTab title="Additional" />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
         <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={3}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch("companyId")} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"productionMaterialsAndWorks"}>
            <NFLookupProduct title="Product" fieldName="productId" width={200} />
            <NFLookupUnit title="Unit" fieldName="unitId" width={200} />
            <NFLookupWarehouse title="Warehouse" fieldName="warehouseId" width={200} companyId={watch("companyId")} />
            <NFLookupDivision companyId={watch("companyId")} title="Division" fieldName="divisionId" width={200} />
            <NFTextInput title="assignment" fieldName="assignment" />
            <NFTextInput title="batch" fieldName="batch" />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <NFormTable fieldArray={"productionManufacturedProducts"}>
            <NFLookupDivision title="divisionId" fieldName="divisionId" width={200} />
            <NFLookupProduct title="productId" fieldName="productId" width={200} />
            <NFLookupUnit title="unitId" fieldName="unitId" width={200} />
            <NFTextInput title="releaseDirection" fieldName="releaseDirection" />
            <NFTextInput title="costShare" fieldName="costShare" />
            <NFIntInput title="quantity" fieldName="quantity" />
            <NFTextInput title="assignment" fieldName="assignment" />
            <NFTextInput title="batch" fieldName="batch" />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <ProductionsDetailFooter/>
    </FormProvider>
  );
};
